<template lang="pug">
.scada-page
  .page-wrapper(:class="{ 'scada-overlay': showOverlay }")
    .header
      .title 利嘉小水力發電設備
      .mode-title.power-mode(v-if="mode === 'power'") 小水力發電供水模式
        //- img(:src='flashSrc')
      .mode-title.origin-mode(v-if="mode === 'origin'") 原有供水模式
        //- img(:src='waterDropSrc')
    .scada-container(ref='container')
      .scada-canvas(ref='canvas')
</template>

<script>
import Konva from 'konva'
export default {
  props: { showOverlay: Boolean },
  data () {
    return {
      /**
       * 切換標題樣式
       */
      mode: 'origin',

      /**
       * 原水模式時長控制
       */
      step: 1,
      STEP_SECONDS: {
        STEP_1: 3 * 1000,
        STEP_2: 1,
        STEP_3: 5 * 1000,
        STEP_4: 5 * 1000,
        STEP_5: 5 * 1000,

        // 原水轉場到發電
        STEP_6: 1
      },

      /**
       * 發電模式時長控制
       */
      powerStep: 1,
      STEP_SECONDS_POWER: {
        STEP_1: 5 * 1000,
        STEP_2: 1,
        STEP_3: 5 * 1000,
        STEP_4: 5 * 1000,
        STEP_5: 5 * 1000,
        STEP_6: 5 * 1000,
        STEP_7: 5 * 1000,
        STEP_8: 5 * 1000,
        STEP_9: 5 * 1000,
        STEP_10: 5 * 1000,
        STEP_11: 1
      },

      /**
       * Canvas 物件
       */
      stage: null,
      pipeline_layer: null,
      flow_layer: null,
      device_layer: null,
      data_layer: null,

      // 管線
      piplines: [
        {
          obj: null,
          src: require('@/assets/scada/img_3dfield_powerflow1.svg'),
          w: 440,
          h: 1560
        },
        {
          obj: null,
          src: require('@/assets/scada/img_3dfield_original.svg'),
          w: 440,
          h: 1560
        }
      ],

      // 水流
      origin_flow: null,
      energy_flow: null,

      // 閥門把手
      valveHandle1: [
        { obj: null, x: 10 + 25, y: 525 + 25, w: 50, h: 50, offsetX: 25, offsetY: 25, type: 'bypass_handle', status: 'normal', rotate: 180, name: 'MO1' }
      ],
      valveHandle2: [
        { obj: null, x: 264 + 25, y: 415 + 25, w: 50, h: 50, offsetX: 25, offsetY: 25, type: 'bypass_handle', status: 'normal', rotate: 180, name: 'MO1' },
        { obj: null, x: 264 + 25, y: 565 + 25, w: 50, h: 50, offsetX: 25, offsetY: 25, type: 'bypass_handle', status: 'normal', rotate: 180, name: 'MO1' },
        { obj: null, x: 374 + 25, y: 1145 + 25, w: 50, h: 50, offsetX: 25, offsetY: 25, type: 'bypass_handle', status: 'normal', rotate: 180, name: 'MO1' }
      ],

      // 原水模式設備
      device: [
        { obj: null, x: 280, y: 216, w: 96, h: 48, type: 'flow_meter', status: 'normal', rotate: 0, name: 'FT1' },
        { obj: null, x: 10, y: 510, w: 50, h: 80, type: 'bypass', status: 'normal', rotate: 0, name: 'MO4' }
      ],
      // 發電模式設備
      device2: [
        { obj: null, x: 268, y: 716, w: 88, h: 48, type: 'mano_meter', status: 'normal', rotate: 0, name: 'FT4' },
        { obj: null, x: 264, y: 400, w: 50, h: 80, type: 'bypass', status: 'normal', rotate: 0, name: 'MO1' },
        { obj: null, x: 264, y: 550, w: 50, h: 80, type: 'bypass', status: 'normal', rotate: 0, name: 'MO2' },
        { obj: null, x: 374, y: 1130, w: 50, h: 80, type: 'bypass', status: 'normal', rotate: 0, name: 'MO3' },

        { obj: null, x: 254, y: 850, w: 180, h: 246, type: 'waterwheel', status: 'normal', rotate: 0, name: '水車' }
        // { obj: null, x: 130, y: 759, w: 92, h: 101, type: 'dynamo', status: 'normal', rotate: 0, name: '發電機' }
      ],

      // 資料框框
      originData: [
        { obj: null, x: 78, y: 187, w: 214, h: 110, status: 'origin', name: '流量計', src: require('@/assets/scada/origin/block1.svg') },
        { obj: null, x: 35, y: 497, w: 219, h: 110, status: 'origin', name: '制水閥', src: require('@/assets/scada/origin/block2.svg') }
      ],
      powerData: [
        { obj: null, x: 78, y: 187, w: 214, h: 110, status: 'origin', name: '流量計', src: require('@/assets/scada/origin/block1.svg') },
        { obj: null, x: 96 - 18, y: 400 - 13, w: 211, h: 110, status: 'origin', name: '制水閥', src: require('@/assets/scada/power/block2.svg') },
        { obj: null, x: 96 - 18, y: 550 - 13, w: 211, h: 110, status: 'origin', name: '入口閥', src: require('@/assets/scada/power/block3.svg') },
        { obj: null, x: 96 - 18, y: 700 - 13, w: 211, h: 110, status: 'origin', name: '壓力計', src: require('@/assets/scada/power/block4.svg') },
        { obj: null, x: 96 - 18, y: 860 - 13, w: 211, h: 110, status: 'origin', name: '導葉閥', src: require('@/assets/scada/power/block5.svg') },
        { obj: null, x: 96 - 18, y: 965 - 13, w: 201, h: 130, status: 'origin', name: '發電機', src: require('@/assets/scada/power/block6.svg') },
        { obj: null, x: 205 - 18, y: 1130 - 13, w: 211, h: 110, status: 'origin', name: '制水閥', src: require('@/assets/scada/power/block2.svg') }
      ],

      // Demo 用
      data: [
        { obj: null, x: 0, y: 0, w: 440, h: 1819, status: 'origin', name: '資料1' },
        { obj: null, x: 0, y: 0, w: 440, h: 1819, status: 'energy', name: '資料2' }
      ],

      /**
       * 圖片路徑
       */
      image: {
        flow_meter: require('@/assets/scada/img_asset_valve_flow_meter.svg'),
        mano_meter: require('@/assets/scada/img_asset_valve_manometer.svg'),
        bypass: require('@/assets/scada/img_asset_valve_joint.svg'),
        bypass_handle: require('@/assets/scada/img_asset_valve.svg'),
        waterwheel: require('@/assets/scada/img_asset_waterwheel.svg'),
        dynamo: require('@/assets/scada/power-motor.svg')
      },
      data_img: {
        origin: require('@/assets/scada/data1.svg'),
        energy: require('@/assets/scada/data2.svg')
      },
      flashSrc: require('@/assets/scada/icon-indi-96-electric.svg'),
      waterDropSrc: require('@/assets/scada/icon-indi-96-waterdrop.svg')
    }
  },
  mounted () {
    this.initStage()
  },
  methods: {
    initStage () {
      const canvas = this.$refs.canvas

      const scale = 1
      this.canvasWidth = 440 * scale
      this.canvasHeight = 1819 * scale

      this.stage = new Konva.Stage({
        container: canvas,
        width: this.canvasWidth,
        height: this.canvasHeight
      })

      this.pipeline_layer = new Konva.Layer()
      this.flow_layer = new Konva.Layer()
      this.device_layer = new Konva.Layer()
      this.top_layer = new Konva.Layer()

      this.stage.add(this.pipeline_layer)
      this.stage.add(this.flow_layer)
      this.stage.add(this.device_layer)
      this.stage.add(this.top_layer)

      this.addWaterFlow()
      this.addPipline()
      this.addDeviceTwo()

      this.addValveOne()
      this.addValveTwo()

      // 加入設備1 (預設顯示)
      this.addDeviceOne()

      // 加入資料 (預設隱藏)
      this.addDataOne()
      this.addDataTwo()

      window.setTimeout(() => {
        this.handleOriginStep()
      }, 3 * 1000)
    },
    handleOriginStep () {
      const _this = this

      if (this.step === 1) {
        console.log('SCADA: STEP_1 原水管線停留, 秒數: ' + this.STEP_SECONDS.STEP_1 / 1000)
        // 原水管線停留
        window.setTimeout(() => {
          this.step = 2
        }, this.STEP_SECONDS.STEP_1)
      }

      if (this.step === 2) {
        console.log('SCADA: STEP_2 閥開 + 原水水流出現, 秒數: ' + this.STEP_SECONDS.STEP_2)

        // 原水水流 fade in
        this.origin_flow.show()
        const tween = new Konva.Tween({
          node: this.origin_flow,
          duration: this.STEP_SECONDS.STEP_2,
          easing: Konva.Easings.EaseInOut,
          opacity: 1
        })
        tween.play()

        // 原水制水閥轉到 0 度 (開啟)
        const target = this.valveHandle1[0].obj
        this.valveHandle1[0].rotate = 0
        const tween2 = new Konva.Tween({
          node: target,
          duration: this.STEP_SECONDS.STEP_2,
          easing: Konva.Easings.EaseInOut,
          rotation: this.valveHandle1[0].rotate,
          onFinish: () => {
            _this.step = 3
          }
        })
        tween2.play()
      }

      if (this.step === 3) {
        console.log('SCADA: STEP_3 原水水流停留, 秒數: ' + this.STEP_SECONDS.STEP_3 / 1000)

        // 原水水流停留
        window.setTimeout(() => {
          this.step = 4
        }, this.STEP_SECONDS.STEP_3)
      }

      if (this.step === 4) {
        console.log('SCADA: STEP_4 流量計資料出現 & 停留, 秒數: ' + this.STEP_SECONDS.STEP_4 / 1000)

        this.originData[0].obj.show()

        // 原水資料1 (流量計) 停留
        window.setTimeout(() => {
          this.step = 5
        }, this.STEP_SECONDS.STEP_4)
      }

      if (this.step === 5) {
        console.log('SCADA: STEP_5 制水閥資料出現 & 停留, 秒數: ' + this.STEP_SECONDS.STEP_5 / 1000)

        this.originData[1].obj.show()

        // 原水資料2 (制水閥) 停留
        window.setTimeout(() => {
          this.step = 6
        }, this.STEP_SECONDS.STEP_5)
      }

      if (this.step === 6) {
        console.log('SCADA: 原水轉場到發電, 秒數: ' + this.STEP_SECONDS.STEP_6)

        this.mode = 'power'

        // 隱藏原水資料
        this.originData[0].obj.hide()
        this.originData[1].obj.hide()

        // 原水水流 fade out
        const tween = new Konva.Tween({
          node: this.origin_flow,
          duration: this.STEP_SECONDS.STEP_6,
          easing: Konva.Easings.EaseInOut,
          opacity: 0
        })
        tween.play()

        // 原水制水閥轉到 180 度 (關閉)
        const target = this.valveHandle1[0].obj
        this.valveHandle1[0].rotate = 180
        const tween2 = new Konva.Tween({
          node: target,
          duration: this.STEP_SECONDS.STEP_2,
          easing: Konva.Easings.EaseInOut,
          rotation: this.valveHandle1[0].rotate,
          onFinish: () => {
            _this.step = 3
          }
        })
        tween2.play()

        // 顯示 設備2
        for (const device of [...this.device2, ...this.valveHandle2]) {
          const target = device.obj
          const tween = new Konva.Tween({
            node: target,
            duration: this.STEP_SECONDS.STEP_6,
            easing: Konva.Easings.EaseInOut,
            opacity: 1
          })
          tween.play()
        }

        // 顯示 管路2
        const pipline = this.piplines[0].obj
        const tween3 = new Konva.Tween({
          node: pipline,
          duration: this.STEP_SECONDS.STEP_6,
          easing: Konva.Easings.EaseInOut,
          opacity: 1,
          onFinish: () => {
            _this.handlePowerStep()
            // 隱藏 管路1
            _this.piplines[1].obj.hide()
          }
        })
        tween3.play()
      }
    },
    handlePowerStep () {
      const _this = this

      if (this.powerStep === 1) {
        console.log('SCADA: STEP_1 發電管線停留, 秒數: ' + this.STEP_SECONDS_POWER.STEP_1 / 1000)

        // 發電管線 停留
        window.setTimeout(() => {
          this.powerStep = 2
        }, this.STEP_SECONDS_POWER.STEP_1)
      }

      if (this.powerStep === 2) {
        console.log('SCADA: STEP_2 閥開 + 發電水流出現, 秒數: ' + this.STEP_SECONDS_POWER.STEP_2)

        // 閥轉到 0 度 (開啟)
        for (const valve of this.valveHandle2) {
          valve.rotate = 0
          const target = valve.obj
          const tween = new Konva.Tween({
            node: target,
            duration: this.STEP_SECONDS_POWER.STEP_2,
            easing: Konva.Easings.EaseInOut,
            rotation: valve.rotate
          })
          tween.play()
        }

        // 水流2 fade in
        this.energy_flow.show()
        const tween = new Konva.Tween({
          node: this.energy_flow,
          duration: this.STEP_SECONDS_POWER.STEP_2,
          easing: Konva.Easings.EaseInOut,
          opacity: 1,
          onFinish: () => {
            _this.powerStep = 3
          }
        })
        tween.play()
      }

      if (this.powerStep === 3) {
        console.log('SCADA: STEP_3 發電水流停留, 秒數: ' + this.STEP_SECONDS_POWER.STEP_3 / 1000)
        // 發電水流 停留
        window.setTimeout(() => {
          this.powerStep = 4
        }, this.STEP_SECONDS_POWER.STEP_3)
      }

      if (this.powerStep === 4) {
        console.log('SCADA: STEP_4 流量計資料出現 & 停留, 秒數: ' + this.STEP_SECONDS_POWER.STEP_4 / 1000)

        // 流量計資料 pop up
        this.powerData[0].obj.show()

        // 流量計資料 停留
        window.setTimeout(() => {
          this.powerStep = 5
        }, this.STEP_SECONDS_POWER.STEP_4)
      }

      if (this.powerStep === 5) {
        console.log('SCADA: STEP_5 制水閥資料出現 & 停留, 秒數: ' + this.STEP_SECONDS_POWER.STEP_5 / 1000)

        // 制水閥資料 pop up
        this.powerData[1].obj.show()

        // 制水閥資料 停留
        window.setTimeout(() => {
          this.powerStep = 6
        }, this.STEP_SECONDS_POWER.STEP_5)
      }

      if (this.powerStep === 6) {
        console.log('SCADA: STEP_6 入口閥資料出現 & 停留, 秒數: ' + this.STEP_SECONDS_POWER.STEP_6 / 1000)

        // 入口閥資料 pop up
        this.powerData[2].obj.show()

        // 入口閥資料 停留
        window.setTimeout(() => {
          this.powerStep = 7
        }, this.STEP_SECONDS_POWER.STEP_6)
      }

      if (this.powerStep === 7) {
        console.log('SCADA: STEP_7 壓力計資料出現 & 停留, 秒數: ' + this.STEP_SECONDS_POWER.STEP_7 / 1000)

        // 壓力計資料 pop up
        this.powerData[3].obj.show()

        // 壓力計資料 停留
        window.setTimeout(() => {
          this.powerStep = 8
        }, this.STEP_SECONDS_POWER.STEP_7)
      }

      if (this.powerStep === 8) {
        console.log('SCADA: STEP_8 導葉閥資料出現 & 停留, 秒數: ' + this.STEP_SECONDS_POWER.STEP_8 / 1000)

        // 導葉閥資料 pop up
        this.powerData[4].obj.show()

        // 導葉閥資料 停留
        window.setTimeout(() => {
          this.powerStep = 9
        }, this.STEP_SECONDS_POWER.STEP_8)
      }

      if (this.powerStep === 9) {
        console.log('SCADA: STEP_9 發電機資料出現 & 停留, 秒數: ' + this.STEP_SECONDS_POWER.STEP_9 / 1000)

        // 發電機資料 pop up
        this.powerData[5].obj.show()

        // 發電機資料 停留
        window.setTimeout(() => {
          this.powerStep = 10
        }, this.STEP_SECONDS_POWER.STEP_9)
      }

      if (this.powerStep === 10) {
        console.log('SCADA: STEP_10 制水閥資料出現 & 停留, 秒數: ' + this.STEP_SECONDS_POWER.STEP_10 / 1000)

        // 制水閥資料 pop up
        this.powerData[6].obj.show()

        // 制水閥資料 停留
        window.setTimeout(() => {
          this.powerStep = 11
        }, this.STEP_SECONDS_POWER.STEP_10)
      }

      if (this.powerStep === 11) {
        console.log('SCADA: 頁面結束, 秒數: ' + this.STEP_SECONDS_POWER.STEP_11)

        const tween = new Konva.Tween({
          node: this.stage,
          duration: this.STEP_SECONDS_POWER.STEP_11,
          easing: Konva.Easings.EaseInOut,
          opacity: 0,
          onFinish: () => {
            _this.$emit('next')
          }
        })
        tween.play()
      }
    },

    /**
     * 顯示圖片到 canvas
     */
    addPipline () {
      const _this = this

      for (const i in this.piplines) {
        const pipline = this.piplines[i]

        const imageObj = new Image()
        imageObj.src = pipline.src

        imageObj.onload = function () {
          pipline.obj = new Konva.Image({
            x: 0,
            y: 0,
            image: imageObj,
            width: pipline.w,
            height: pipline.h,
            opacity: i === '1' ? 1 : 0
          })
          _this.pipeline_layer.add(pipline.obj)
        }
      }
    },
    addWaterFlow () {
      const originLine = new Konva.Line({
        points: [
          0, 0,
          246, 0,
          246, 202,
          -74, 202,
          -74, 1374,
          300, 1374
        ],
        stroke: '#96ffff',
        strokeWidth: 8,
        lineCap: 'round',
        lineJoin: 'round',
        dash: [10, 18],
        visible: false,
        opacity: 0,

        shadowColor: 'black',
        shadowOpacity: 0.4,
        shadowBlur: 5,
        shadowOffset: { x: 0, y: 1 }
      })
      originLine.move({ x: 110, y: 126 })
      this.origin_flow = originLine
      this.flow_layer.add(this.origin_flow)

      const energyLine = new Konva.Line({
        points: [
          0, 0,
          246, 0,
          246, 202,
          180, 202,
          180, 907,
          288, 907,
          288, 1162,
          -74, 1162,
          -74, 1374,
          300, 1374
        ],
        stroke: '#ffeb00',
        strokeWidth: 8,
        lineCap: 'round',
        lineJoin: 'round',
        dash: [10, 18],
        visible: false,
        opacity: 0,

        shadowColor: 'black',
        shadowOpacity: 0.4,
        shadowBlur: 5,
        shadowOffset: { x: 0, y: 1 }
      })
      energyLine.move({ x: 110, y: 126 })
      this.energy_flow = energyLine
      this.flow_layer.add(this.energy_flow)

      let i = 0
      const anim = new Konva.Animation(function (frame) {
        i += 0.5
        originLine.dashOffset(-(i))
        energyLine.dashOffset(-(i))
      }, this.line_layer)

      anim.start()
    },
    addDeviceOne () {
      const _this = this
      for (const d of this.device) {
        const img = new Image()

        img.onload = function () {
          d.obj = new Konva.Image({
            x: d.x,
            y: d.y,
            image: img,
            width: d.w,
            height: d.h,
            rotation: d.rotate
          })
          _this.device_layer.add(d.obj)
        }
        img.src = this.image[d.type]
      }
    },
    addDeviceTwo () {
      const _this = this
      for (const d of this.device2) {
        const img = new Image()

        img.onload = function () {
          d.obj = new Konva.Image({
            x: d.x,
            y: d.y,
            image: img,
            width: d.w,
            height: d.h,
            rotation: d.rotate,
            opacity: 0
          })
          _this.device_layer.add(d.obj)
        }
        img.src = this.image[d.type]
      }
    },
    addValveOne () {
      const _this = this
      for (const d of this.valveHandle1) {
        const img = new Image()

        img.onload = function () {
          d.obj = new Konva.Image({
            x: d.x,
            y: d.y,
            image: img,
            width: d.w,
            height: d.h,
            rotation: d.rotate,
            offsetX: d.offsetX,
            offsetY: d.offsetY
          })
          _this.top_layer.add(d.obj)
        }
        img.src = this.image[d.type]
      }
    },
    addValveTwo () {
      const _this = this
      for (const d of this.valveHandle2) {
        const img = new Image()

        img.onload = function () {
          d.obj = new Konva.Image({
            x: d.x,
            y: d.y,
            image: img,
            width: d.w,
            height: d.h,
            rotation: d.rotate,
            opacity: 0,
            offsetX: d.offsetX,
            offsetY: d.offsetY
          })
          _this.top_layer.add(d.obj)
        }
        img.src = this.image[d.type]
      }
    },
    addDataOne () {
      const _this = this

      for (const d of this.originData) {
        const img = new Image()

        img.onload = function () {
          d.obj = new Konva.Image({
            x: d.x,
            y: d.y,
            image: img,
            width: d.w,
            height: d.h,
            visible: false
          })
          _this.top_layer.add(d.obj)
        }
        img.src = d.src
      }
    },
    addDataTwo () {
      const _this = this

      for (const d of this.powerData) {
        const img = new Image()

        img.onload = function () {
          d.obj = new Konva.Image({
            x: d.x,
            y: d.y,
            image: img,
            width: d.w,
            height: d.h,
            visible: false
          })
          _this.top_layer.add(d.obj)
        }
        img.src = d.src
      }
    }
  },
  watch: {
    step: {
      handler (nVal, oVal) {
        if (nVal > oVal) {
          this.handleOriginStep()
        }
      }
    },
    powerStep: {
      handler (nVal, oVal) {
        if (nVal > oVal) {
          this.handlePowerStep()
        }
      }
    }
  }
}
</script>

<style lang="scss">
.scada-page {
  width: 100%;
  height: 100%;

  opacity: 0;
  animation-name: fade-in;
  animation-duration: 2s; // 頁面 fade in
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;

  .page-wrapper {
    width: 100%;
    height: 100%;
  }

  .header {
    text-align: center;
    height: 200px;
    padding-top: 15px;
    box-sizing: border-box;
    background-image: linear-gradient(to bottom, rgba(0, 220, 255, 0.4), rgba(0, 220, 255, 0));

    .title {
      font-family: 'Noto Sans TC';
      font-size: 36px;
      letter-spacing: 10px;
      font-weight: bold;
      margin-bottom: 17px;
      color: #0064a0;
      transform: translateX(5px);
    }

    .mode-title {
      margin: 0 auto;
      width: 400px;
      height: 80px;
      border-radius: 12px;
      box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.3);

      font-family: 'Noto Sans TC';
      font-size: 36px;
      // font-weight: regular;
      line-height: 72px;
      text-align: center;
      text-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);

      position: relative;
      img {
        position: absolute;
        top: 58px;
        left: 200px;
        transform: translateX(-50%);
      }

      background: #0078ff;
      border: solid 2px #00dcff;
    }

    .power-mode {
      color: #ffeb00;
      letter-spacing: 1.5px;
    }

    .origin-mode {
      color: #96ffff;
      letter-spacing: 12.86px;
    }
  }

  // 進到 scada 時的轉場遮罩
  .scada-overlay {
    mask-image: linear-gradient(0deg, #000 0%, #000 30%, #0000 67%, #0000 100%);
    mask-size: 100% 300%;

    animation-name: clip-fade;
    animation-duration: 0.1s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-timing-function: ease-in-out;
  }

  .scada-container {
    width: 100%;
    height: 100%;
    padding: 50px 20px 0 20px;
  }

  @keyframes clip-fade {
    0% {
      mask-position: top;
    }

    100% {
      mask-position: bottom;
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
}
</style>
